<template>
  <section class="color-new-light-grey">
    <v-container :class="{ 'pa-0' : this.$vuetify.breakpoint.smAndDown }">
      <v-row justify="center">
        <v-col class="shrink">
          <h1 class="text-h1">{{ $t('myInformation')}}</h1>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12">
          <v-card :class="{ 'radius-card' : this.$vuetify.breakpoint.mdAndUp }">
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <h4 class="text-h4">{{ $t('personalInfo') }}</h4>
                  <v-divider></v-divider>
                </v-col>
              </v-row>
              <v-row align="center" data-matomo-mask>
                <v-col cols="3" class="text-center hidden-sm-and-down" >
                  <v-icon x-large>fas fa-address-book</v-icon>
                </v-col>
                <v-col cols="12" md="9">
                  <v-row>
                    <v-col cols="12">
                      <p class="ok-title color-new-link-blue--text">{{ $t('debtorName') }}</p>
                      <p class="ok-subtitle">{{ debtor.name }}</p>
                    </v-col>
                  </v-row>
                  <v-row v-if="debtor.address.length > 0">
                    <v-col cols="12" sm="6">
                      <p class="ok-title color-new-link-blue--text">{{ $t('postOffice') }}</p>
                      <p class="ok-subtitle">{{ debtor.address[0].city != null ?  debtor.address[0].postAddress + ', ' + debtor.address[0].city : debtor.address[0].postAddress }}</p>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <p class="ok-title color-new-link-blue--text">{{ $t('debtorAddress') }}</p>
                      <p class="ok-subtitle">{{ debtor.address[0].streetAddress }}</p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="6">
                      <p class="ok-title color-new-link-blue--text">{{ $t('debtorPhone') }}</p>
                      <p class="ok-subtitle" v-for="phone in debtor.contactInformation.phones" :key="phone.number">{{ phone.number }}</p>
                      <v-form @submit.prevent="addContactInfo('phone')" class="hidden-md-and-up">
                        <v-row no-gutters align="center">
                          <v-col class="pr-0" cols="10" sm="9">
                            <v-text-field :label="$t('debtorPhone')"
                                          v-model="phoneNumber"
                                          @blur="$v.phoneNumber.$touch()"
                                          @change="$v.phoneNumber.$touch()"
                                          prefix="+358"
                                          class="long-prefix"
                                          placeholder=" "
                                          :error-messages="phoneNumberError">
                            </v-text-field>

                          </v-col>
                          <v-col class="pa-0" cols="2">
                            <v-btn text icon color="success" @click="addContactInfo('phone')" :disabled="$v.phoneNumber.$error || !$v.phoneNumber.$dirty">
                              <v-icon>fas fa-plus-circle</v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="6">
                      <p class="ok-title color-new-link-blue--text">{{ $t('debtorEmail') }}</p>
                      <p class="ok-subtitle" v-for="email in debtor.contactInformation.emails" :key="email.emailAddress">{{ email.emailAddress }}</p>
                      <v-form @submit.prevent="addContactInfo('email')" class="hidden-md-and-up">
                        <v-row no-gutters align="center">
                          <v-col class="pr-0" cols="10" sm="9">
                            <v-text-field :label="$t('debtorEmail')"
                                          v-model="emailAddress"
                                          @blur="$v.emailAddress.$touch()"
                                          @change="$v.emailAddress.$touch()"
                                          :error-messages="emailAddressError">
                            </v-text-field>
                          </v-col>
                          <v-col class="pa-0" cols="2">
                            <v-btn text icon color="success" @click="addContactInfo('email')" :disabled="$v.emailAddress.$error || !$v.emailAddress.$dirty">
                              <v-icon>fas fa-plus-circle</v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-col>
                  </v-row>
                  <v-row class="hidden-sm-and-down">
                    <v-col cols="12" sm="6">
                      <v-form @submit.prevent="addContactInfo('phone')">
                        <v-row no-gutters align="center">
                          <v-col cols="8">
                            <v-text-field :label="$t('debtorPhone')"
                                          v-model="phoneNumber"
                                          @blur="$v.phoneNumber.$touch()"
                                          @change="$v.phoneNumber.$touch()"
                                          prefix="+358"
                                          class="long-prefix"
                                          placeholder=" "
                                          persistent-hint
                                          :error-messages="phoneNumberError">
                            </v-text-field>
                          </v-col>
                          <v-col cols="3">
                            <v-btn small tile color="success" @click="addContactInfo('phone')" :disabled="$v.phoneNumber.$error || !$v.phoneNumber.$dirty">{{ $t('add') }}</v-btn>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-form @submit.prevent="addContactInfo('email')">
                        <v-row no-gutters align="center">
                          <v-col cols="8">
                            <v-text-field :label="$t('debtorEmail')"
                                          v-model="emailAddress"
                                          @blur="$v.emailAddress.$touch()"
                                          @change="$v.emailAddress.$touch()"
                                          :error-messages="emailAddressError">
                            </v-text-field>
                          </v-col>
                          <v-col cols="3">
                            <v-btn small tile color="success" @click="addContactInfo('email')" :disabled="$v.emailAddress.$error || !$v.emailAddress.$dirty">{{ $t('add') }}</v-btn>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-col>
                  </v-row>
                  <v-row no-gutters  v-if="(!debtor.isCompany && debtor.contactInformation.emails.length > 0) || debtor.contactInformation.phones.length > 0">
                    <v-col cols="12">
                      <p class="ok-title color-new-link-blue--text">{{ $t('communication') }}</p>
                    </v-col>
                    <v-col cols="12">
                      <v-switch v-if="!debtor.isCompany && debtor.contactInformation.emails.length > 0" :label="$t('emailMsgAllowed')" v-model="debtor.contactInformation.isEmailAllowed" @change="allowContactType('email')" />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <h4 class="text-h4">{{ $t('infoAboutMe') }}</h4>
                  <v-divider></v-divider>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="3" class="text-center hidden-sm-and-down">
                  <v-icon x-large>fas fa-info-circle</v-icon>
                </v-col>
                <v-col cols="12" md="9">
                  {{ $t('gdprText') }}
                  <a target="_blank" :href="$t('gdprLink')">{{ $t('gdprHere') }}</a>
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col cols="12">
                  <v-divider></v-divider>
                </v-col>
                <v-col cols="12">
                  <p class="text-center mt-4 mb-0">{{ $t('infoNotUpdated') }}</p>
                  <p class="text-center">{{ $t('takeCCcontact') }}</p>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
  import { required, numeric, email, minLength, maxLength } from 'vuelidate/lib/validators'

  const isNoLeadingZero = (value) => !value.startsWith('0')

  export default {
    data: function () {
      return {
        emailAddress: '',
        phoneNumber: '',
        allowPhone: false,
        allowEmail: false
      }
    },
    methods: {
      allowContactType (type) {
        let payload = { ContactType: type, Allow: type === 'phone' ? this.debtor.contactInformation.isSMSAllowed : this.debtor.contactInformation.isEmailAllowed }
        this.$store.dispatch('allowContact', payload)
      },
      addContactInfo (type) {
        if (type === 'phone') {
          this.formatPhoneNumber()
        }
        let payload = { ContactType: type, Text: type === 'phone' ? this.phoneNumber : this.emailAddress, Allow: type === 'phone' ? this.debtor.contactInformation.isSMSAllowed : this.debtor.contactInformation.isEmailAllowed }

        if (type === 'phone' && !this.$v.phoneNumber.$error) {
          this.$store.dispatch('addDebtorContact', payload)
          this.phoneNumber = ''
          this.$matomo && this.$matomo.trackEvent("Information", "Edit Personal Information", "Add Phone")
        }
        if (type === 'email' && !this.$v.emailAddress.$error) {
          this.$store.dispatch('addDebtorContact', payload)
          this.emailAddress = ''
          this.$matomo && this.$matomo.trackEvent("Information", "Edit Personal Information", "Add Email")
        }
      },
      formatPhoneNumber () {
        if(this.phoneNumber.startsWith('0')) {
          this.phoneNumber = this.phoneNumber.substring(1)
        }
      },
    },
    computed: {
      debtor () {
        return this.$store.getters.debtor
      },
      phoneNumberError () {
        const errors = []
        if (!this.$v.phoneNumber.$dirty || this.phoneNumber === '') return errors
        !this.$v.phoneNumber.required && errors.push(this.$t('phoneErrors.required'))
        !this.$v.phoneNumber.numeric && errors.push(this.$t('phoneErrors.numeric'))
        !this.$v.phoneNumber.minLength && errors.push(this.$t('phoneErrors.length'))
        !this.$v.phoneNumber.maxLength && errors.push(this.$t('phoneErrors.length'))
        !this.$v.phoneNumber.isNoLeadingZero && errors.push(this.$t('phoneErrors.leadingZero'))

        return errors
      },
      emailAddressError () {
        const errors = []
        if (!this.$v.emailAddress.$dirty || this.emailAddress === '') return errors
        !this.$v.emailAddress.required && errors.push(this.$t('emailErrors.required'))
        !this.$v.emailAddress.email && errors.push(this.$t('emailErrors.email'))
        return errors
      }
    },
    validations: {
      phoneNumber: {
        required,
        numeric,
        minLength: minLength(1),
        maxLength: maxLength(12),
        isNoLeadingZero
      },
      emailAddress: {
        required,
        email
      }
    }
  }
</script>

<i18n>
  {
  "fi": {
  "myInformation": "Yhteystietoni",
  "personalInfo": "Henkilötiedot",
  "debtorName": "Nimi",
  "postOffice": "Postitoimipaikka",
  "debtorAddress": "Katuosoite",
  "debtorPhone": "Puhelin",
  "smsAllowedText": "Tekstiviesti sallittu",
  "Yes": "Kyllä",
  "No": "Ei",
  "addPhone": "Lisää Puhelinnumero",
  "validPhoneMsg": "Varmista että puhelinnumero on oikeassa muodossa",
  "validEmailMsg": "Varmista että puhelinnumero on oikeassa muodossa",
  "debtorEmail": "Sähköposti",
  "emailMsgAllowed": "Haluan viestit sähköpostitse",
  "addEmail": "Lisää Sähköposti",
  "communication": "Yhteydenpito",
  "infoAboutMe": "Tiedot minusta",
  "infoNotUpdated": "Onko jokin tämän sivun tiedosta virheellinen tai vanhentunut?",
  "takeCCcontact": "Ota yhteyttä asiakaspalveluun",
  "gdprText": "Voit lukea siitä miten B2 Impact käsittelee tietojasi tarkemmin tietosuojaselosteestamme. Tietosuojaselosteen löydät kotisivuiltamme, lue enemmän ",
  "gdprLink": "https://www.b2-impact.fi/b2-impact/tietosuojaseloste/",
  "gdprHere": "tästä",
  "phoneErrors": {
    "required": "Syötä puhelinnumero",
    "numeric": "Syötä vain numeroarvoja",
    "length": "Puhelinnumero saa olla 1-12 merkkiä pitkä",
    "leadingZero": "Puhelinnumeron ei tule alkaa nollalla"
  },
  "emailErrors": {
    "required": "Syötä sähköpostiosoite",
    "email": "Sähköpostiosoite on väärässä muodossa"
  }
  },
  "se": {
  "myInformation": "Mina kontaktuppgifter",
  "personalInfo": "Mina Uppgifter",
  "debtorName": "Namn",
  "postOffice": "Postanstalt",
  "debtorAddress": "Adress",
  "debtorPhone": "Telefon",
  "smsAllowedText": "SMS-utskick tillåtet",
  "Yes": "Ja",
  "No": "Nej",
  "addPhone": "Lägg till Telefonnummer",
  "validPhoneMsg": "Kontrollera att telefonnumret är i rätt format",
  "validEmailMsg": "Kontrollera att E-post är i rätt format",
  "debtorEmail": "E-post",
  "emailMsgAllowed": "Jag vill ha brev per-e-post",
  "addEmail": "Lägg till E-post",
  "communication": "Kommunikation",
  "infoAboutMe": "Information Om Mig",
  "infoNotUpdated": "Finns det information som behöver uppdateras?",
  "takeCCcontact": "Ta kontakt med vår kundtjänst",
  "gdprText": "Du kan läsa mer om hur B2 Impact hanterar dina personuppgifter i vår dataskyddsbeskrivning. Beskrivningen hittar du på våra hemsidor, läs mer ",
  "gdprLink": "https://www.b2-impact.fi/sv/b2-impact/dataskydd/",
  "gdprHere": "här",
  "phoneErrors": {
    "required": "Fyll i ditt telefonnumer",
    "numeric": "Telefonnumer bör vara numeriskt",
    "length": "Telefonnumret bör vara mellan 1-12 tecken",
    "leadingZero": "Telefonnumret bör inte börja med noll"
  },
  "emailErrors": {
    "required": "Fyll i din e-postadress",
    "email": "E-postadressen är i fel format"
  }
  },
  "en": {
  "myInformation": "My contact information",
  "personalInfo": "My Information",
  "debtorName": "Name",
  "postOffice": "Postoffice",
  "debtorAddress": "Address",
  "debtorPhone": "Phone",
  "smsAllowedText": "Sending of SMS allowed",
  "Yes": "Yes",
  "No": "No",
  "addPhone": "Add Phonenumber",
  "validPhoneMsg": "Please check that phonenumber is in correct format",
  "validEmailMsg": "Email should be in correct format",
  "debtorEmail": "Email Address",
  "emailMsgAllowed": "Receiving letters via email allowed",
  "addEmail": "Add Emailadddress",
  "communication": "Communication",
  "infoAboutMe": "Information About Me",
  "infoNotUpdated": "Is there information that needs to be updated?",
  "takeCCcontact": "Contact our customer service",
  "gdprText": "You can read more about how B2 Impact manages your personal information in our privacy policy description. The privacy policy is available on our web pages, read more ",
  "gdprLink": "https://www.b2-impact.fi/en/b2-impact/privacy-policy/",
  "gdprHere": "here",
  "phoneErrors": {
    "required": "Fill in your phone number",
    "numeric": "The phone number must be numeric",
    "length": "The phone number must be between 1-12 characters",
    "leadingZero": "Phone number must not start with zero"
  },
  "emailErrors": {
    "required": "Fill in your e-mail address",
    "email": "The e-mail address is in the wrong format"
  }
  }
  }
</i18n>
